<app-router-link
  [params]="cosmeticRouterLinkParams()"
  [route]="Route.PL_CosmeticDetails">
  <div class="relative w-full pt-[100%]">
    <div class="absolute inset-0">
      @if (imageSrc(); as imageSrc) {
        <app-image-thumbnail size="full">
          <img
            class="object-contain"
            [alt]="imageAlt()"
            [fill]="true"
            [ngSrc]="imageSrc!" />
        </app-image-thumbnail>
      }
    </div>
  </div>
</app-router-link>

<div class="flex flex-col">
  <app-router-link
    [params]="brandRouterLinkParams()"
    [route]="Route.PL_BrandDetails">
    <div class="py-2 font-bold uppercase hover:underline">
      {{ brandName() }}
    </div>
  </app-router-link>

  <div class="text-sm uppercase">
    <app-router-link
      [params]="cosmeticRouterLinkParams()"
      [route]="Route.PL_CosmeticDetails">
      <div class="text-sm uppercase hover:underline">
        {{ name() }}
      </div>
    </app-router-link>
  </div>
</div>

<div class="flex justify-end text-2xl">
  <app-router-link
    [params]="cosmeticRouterLinkParams()"
    [route]="Route.PL_CosmeticDetails">
    <span
      pTooltip="Więcej o produkcie"
      tooltipPosition="bottom">
      <app-icon [icon]="Icon.ThreeDots" />
    </span>
  </app-router-link>
</div>
